import { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { findIndex } from 'lodash-es';

const AdaptFormControl = styled(FormControl)`
  && {
    background: #ffffff;
    border-radius: 2px;
    color: #3f4851;
    border: 1px solid #dbe1e6;
    margin-left: auto;

    .MuiInput-underline:before,
    .MuiInput-underline:after {
      border: 0;
    }
    .MuiInput-underline:hover:not(.Mui-disabled):before {
      border-bottom: 0;
    }

    ${({ isWhite }) =>
      isWhite &&
      css`
        background-color: transparent;
        color: #fff;
        border: 1px solid #fff;

        .MuiSelect-icon {
          color: #fff;
        }
      `}
  }
`;
const AdaptSelect = styled(Select)`
  && {
    padding: 0;
    border-radius: 2px;
    min-width: 100px;

    ${({ isWhite }) =>
      isWhite &&
      css`
        color: #fff;
      `}

    > div {
      padding: 3px 38px 3px 8px;
      font-size: 12px;
      width: 54px;
      text-align: left;
    }
    .MuiMenu-list {
      padding: 0;
    }
  }
`;
const AdaptMenuItem = styled(MenuItem)`
  && {
    font-size: 12px;
    min-height: 35px;
  }
`;

const languages = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'de',
    label: 'Deutsch',
  },
];

const SwitchLg = ({ variant }) => {
  const [, i18n] = useTranslation();
  const [selected, setSelected] = useState(i18n.language ?? '');

  const checkingLg = (key) => {
    if (key) return key;
    return findIndex(languages, ['value', selected]) !== -1 ? selected : 'en';
  };

  const handleMenuItemClick = (key = '') => {
    i18n.changeLanguage(checkingLg(key));
  };

  return (
    <AdaptFormControl isWhite={variant === 'white'}>
      <AdaptSelect
        isWhite={variant === 'white'}
        labelId="language-select-label"
        id="language-select"
        value={checkingLg()}
        onChange={(event) => {
          handleMenuItemClick(event.target.value);
          setSelected(event.target.value);
        }}
      >
        {languages.map((language) => (
          <AdaptMenuItem key={language.value} value={language.value}>
            {language.label}
          </AdaptMenuItem>
        ))}
      </AdaptSelect>
    </AdaptFormControl>
  );
};
SwitchLg.propTypes = {
  variant: PropTypes.string,
};
export default SwitchLg;
